export default function validatePhoneNumber(number) {
  if (number.trim().length === 0) {
    return false;
  }
  return /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/.test(number);
}
